import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { AngularFireDatabase, FirebaseListObservable } from "angularfire2/database-deprecated";
import { RouterModule, Router } from '@angular/router';
import { FirebaseApp } from 'angularfire2';
import { uploadService } from '../../../../../services/uploadService'
import { Upload } from '../../../../../entities/upload'
@Component({
  selector: 'app-addproduct',
  templateUrl: './addproduct.component.html',
  styleUrls: ['./addproduct.component.css']
})
export class AddproductComponent implements OnInit {

  codeProduct;
  nameProduct;
  priceProduct;
  TypeProduct;
  weigth;
  detailProduct;
  ItemDropdown;

  // variable Upload Image product
  urlPhoto: any[] = [];
  filesToProduct: any[] = [];
  selectedFilesProduct: FileList;
  currentUpload: Upload;
  currentUpload2: Upload;
  currentUpload3: Upload;
  constructor(private _location: Location, public upSvc: uploadService, private af: AngularFireDatabase, private firebaseApp: FirebaseApp) {
    let snap = this.af.list('Menu');
    snap.subscribe((snapitem) => {
      this.ItemDropdown = snapitem;
    })

  }

  ngOnInit() {
  }
  backClicked() {
    this._location.back();
  }
  detectProductFiles(event) {
    if (event.target.files && event.target.files[0] && event.target.files.length > 0) {
      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.urlPhoto.push(event.target.result);
      }
      reader.readAsDataURL(event.target.files[0]);
    }
    if (event.target.files.length > 0) {
      if (this.filesToProduct.length < 3) {
        this.filesToProduct.push(event.target.files);
      } else {
        alert("Select เกินกำหนด")
      }
    }
  }
  addProduct() {
    let filesProduct = this.filesToProduct;
    let dataItem = {
      id: this.codeProduct,
      name: this.nameProduct,
      price: this.priceProduct,
      type: this.TypeProduct,
      weigth: this.weigth,
      photo: '',
      photo2: '',
      photo3: '',
      detailProduct: this.detailProduct
    }

    if (filesProduct.length > 0 && this.codeProduct != '' && this.nameProduct != '' && this.priceProduct != '' && this.TypeProduct != '' && this.weigth != '' && this.detailProduct != '') {
      if (filesProduct.length == 1) {
        let file = filesProduct[0].item(0)
        this.currentUpload = new Upload(file);
        this.upSvc.addUpProduct(dataItem, this.currentUpload)
      } else if (filesProduct.length == 2) {
        let file = filesProduct[0].item(0)
        let file2 = filesProduct[1].item(0)

        this.currentUpload = new Upload(file);
        this.currentUpload2 = new Upload(file2);

        this.upSvc.addUpProduct2Image(dataItem, this.currentUpload, this.currentUpload2)
      } else if (filesProduct.length == 3) {
        let file = filesProduct[0].item(0)
        let file2 = filesProduct[1].item(0)
        let file3 = filesProduct[2].item(0)

        this.currentUpload = new Upload(file);
        this.currentUpload2 = new Upload(file2);
        this.currentUpload3 = new Upload(file3);
        this.upSvc.addUpProduct3Image(dataItem, this.currentUpload, this.currentUpload2, this.currentUpload3)
      }
    } else {
      alert('ข้อมูล ไม่ครบถ้วน')
    }

  }

}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/admin/page/product-list/view/addproduct/addproduct.component.ts